import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { DayjsTransformReturn } from 'frontend-utils/transforms/dayjs';

export type CapacityMeta = {
  totals: {
    available_rooms: number;
    out_of_order_rooms: number;
    physical_rooms: number;
  };
};

export default class BudgetForecastCapacity extends Model {
  [Type] = 'budget-forecast/capacity' as const;

  @attr('number') declare availableRooms: number;
  @attr('dayjs') declare date: NonNullable<DayjsTransformReturn>;

  @attr('number') declare outOfOrderRooms: number;
  @attr('number') declare physicalRooms: number;
}
